import Navbar from './components/Navbar.js';
import Hero from './components/Hero.js';
import Features from './components/Features.js';
import HowItWorks from './components/HowItWorks.js';
import Pricing from './components/Pricing.js';
import CTA from './components/CTA.js';
import Footer from './components/Footer.js';

function App() {
  return (
    <div className="min-h-screen bg-ink text-bone">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
